<template>
    <CList :pConfigList="ConfigList" :segurity="segurity">
        <template slot="bodyForm">
            <CLoader :pConfigLoad="ConfigLoad">
                <template slot="BodyFormLoad">
                    <form id="FormArticulosWeb" class="form-horizontal" method="post" autocomplete="off" onSubmit="return false">

                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
                               <h6>Seleccion de Esferas</h6>
                                <treeselect v-model="listaEsferasSelected"
                                            :value-consists-of="'ALL_WITH_INDETERMINATE'"
                                            :multiple="true"
                                            :options="listaEsferas"
                                            :show-count="true"
                                            @input="updateEsferasSelect()"
                                            @deselect="remueveEsfera($event)"
                                            :clearable="false"
                                            placeholder="Selecciona Esferas"/>

                        
                            </div>
                            <div class="col-12 col-sm-12 col-md-6 col-lg-8 col-xl-8">
                                <CLoader :pConfigLoad="ConfigLoad" style="overflow-y: scroll; max-height: 450px;">
                                    <template slot="BodyFormLoad">
                                        <table class="table table-hover table-striped table-sm" style="margin-top: 30px;">
                                            <thead class="bg-light sticky-top top-0" >
                                                <tr>
                                                    <th>Esfera</th>
                                                    <th>Cilindros disponibles</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in listaEsferasxCilindros" :key="index"> 
                                                    <td>{{  parseFloat(item.RangoEsfera) > 0 ? '+'+item.RangoEsfera : item.RangoEsfera}}</td>
                                                    <td width="45%">
                                                        <treeselect v-model="item.cilindroSelected"
                                                            :value-consists-of="'ALL_WITH_INDETERMINATE'"
                                                            :multiple="true"
                                                            :options="listaCilindros"
                                                            :show-count="true"
                                                            @select="agregaCilindros(item.RangoEsfera,$event)"
                                                            @deselect="remueveCilindro(item.RangoEsfera,$event)"
                                                            :clearable="false"
                                                            placeholder="Selecciona Cilindros"/>
                                                    </td>
                                                </tr>
                                                <CSinRegistros :pContIF="listaEsferasxCilindros.length" :pColspan="2"/>
                                            </tbody>
                                        
                                        </table>
                                    </template>
                                </CLoader>
                            </div>
                        </div>

                        <div class="row mt-5">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-end">
                                <button class="btn btn-primary" type="button" @click="guardar()" >
                                    <i class="fa fa-spinner fa-pulse fa-1x fa-fw" style="display: none;"></i>
                                    Guardar
                                </button>
                            </div>
                        </div>

                    </form>
                </template>
            </CLoader>
        </template>
    </CList>
</template>
<script>
import CLoader from '@/components/CLoader.vue';
import CSinRegistros from '@/components/CSinRegistros.vue';
const EmitEjecuta = 'seccionArticulosxGraduaciones';

export default {
    name:'ArticulosxGraduaciones',
    props:['pObjArticuloWeb','pProducto','poBtnSave'],
    components:{
        CLoader,
        CSinRegistros
    },
    data() {
        return {

            ConfigList:{
                Title: 'Configuracion de Graduaciones',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
				ShowTitleFirst: false,
                TypeBody: 'Form',
				EmitSeccion: EmitEjecuta,
            },
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            segurity: {},
            errorvalidacion: [],
            OrigenList:'',
            
            ArticuloWeb:{
                IdArticuloWeb:0,
                IdTipoLente:0,
            },

            // OPCIONES
            listaEsferas: [],
            esferasResp:[],
            listaCilindros: [],

            // V-MODELS
            ArticulosxGraduacionResp: [],
            listaEsferasSelected: [],
            listaEsferasxCilindros:[],
            
            listEsferasEliminadas: [],
            listCilindrosEliminados: [],
        }
    },
    methods: {
        guardar() {
            this.errorvalidacion=[];

            if(this.listaEsferasxCilindros.length <= 0){
                this.$toast.warning("Seleccione una Esfera");
            }
            let newRequest = {
                IdArticuloWeb:     this.ArticuloWeb.IdArticuloWeb,
                IdTipoLente:     this.ArticuloWeb.IdTipoLente,
                IdSublinea:     this.ArticuloWeb.IdSublinea,
                listaEsferaxTallas:  this.listaEsferasxCilindros,
                listaEsferasEliminados: this.listEsferasEliminadas,
                listaCilindrosEliminados: this.listCilindrosEliminados,

            };

            this.$http.post('articulostabgraduaciones', newRequest)
            .then( (res) => {
                this.$toast.success("Información Guardada");
                this.getEsferasMatch();

            }).catch( err => {
                console.error(err);
                this.$toast.error(err.response.data.message);

            });
        },

        // ESFERAS
        getEsferasMatch() {
            this.ConfigLoad.ShowLoader = true;
            let newRequest = {
                IdArticuloWeb: this.ArticuloWeb.IdArticuloWeb,
                IdTipoLente: this.ArticuloWeb.IdTipoLente
            };
            this.limpiar();

            this.$http.post('articulosxgraduaciones/match',newRequest)
            .then( (res) => {
                console.log(res.data);
                
                // CILINDROS (Fijos)
                let respCilindros   = res.data.data.Cilindros;
                this.listaCilindros = [];
                respCilindros.forEach(element => {
                    this.listaCilindros.push({
                        id: element.Valor,
                        label: parseFloat(element.Valor) > 0 ? '+'+element.Valor : element.Valor,
                    });
                });

                // ESFERAS (Dinamico)
                let respEsferas     = res.data.data.Esferas;
                this.listaEsferas   = [];
                //this.esferasResp    = respEsferas
                respEsferas.forEach(element => {
                    this.listaEsferas.push({
                        id: element.Valor,
                        label: parseFloat(element.Valor) > 0 ? '+'+element.Valor : element.Valor,
                    });
                });
        
                

                // TALLAS X COLORES
                let algo = this;
                let artxgrad  = res.data.data.ArticulosxGraduacion;
                this.ArticulosxGraduacionResp = artxgrad;
                artxgrad.forEach(function(element) {
                    algo.getEsferasSelected(element.RangoEsfera);
                });

            }).catch( err => {
                console.log(err);
                /*if(err.response.data.errors){
                  this.errorvalidacion=err.response.data.errors;
                }else{
                  this.$toast.error(err.response.data.message);
                }*/

            }).finally(() =>{
                this.ConfigLoad.ShowLoader = false;
            });
        },

        getEsferasSelected(pValorEsfera) {
            
            let objEsfera = this.listaEsferasSelected.filter( e => parseFloat(e) === parseFloat(pValorEsfera));
           

            if (objEsfera.length > 0) {
                return false
                
            }else {
                
                this.listaEsferasSelected.push(pValorEsfera);
                
                let cilindroSelect   = this.ArticulosxGraduacionResp.filter( e => parseFloat(e.RangoEsfera) === parseFloat(pValorEsfera));
                let cilindroSimple     = [];
                let cilindroComplex    = [];

                if(cilindroSelect.length > 0) {

                    for (let i = 0; i < cilindroSelect.length; i++) {
                        
                        cilindroSimple.push(cilindroSelect[i].RangoCilindro);
                        cilindroComplex.push({
                            IdArticuloTabGraduacion: cilindroSelect[i].IdArticuloTabGraduacion,
                            IdArticuloWeb: cilindroSelect[i].IdArticuloWeb,
                            IdTipoLente: cilindroSelect[i].IdTipoLente,
                            RangoEsfera: cilindroSelect[i].	RangoEsfera,
                            RangoCilindro: cilindroSelect[i].RangoCilindro,
                        });
                    }

                    this.listaEsferasxCilindros.push({
                        RangoEsfera: pValorEsfera,
                        cilindroSelected: cilindroSimple,
                        cilindrosComplex: cilindroComplex
                  
                    });
                }

                return true;

            }
        
        },

        updateEsferasSelect(){
            let algo = this;
            this.listaEsferasSelected.forEach(function(element) {
                algo.addingElements(element);
            });
        },

        addingElements(pValorEsfera){
            let objEsfera = this.listaEsferasxCilindros.filter( e => parseInt(e.RangoEsfera) === parseInt(pValorEsfera));
           

            if (objEsfera.length > 0) {
                return false
                
            }else {
                  
                let cilindroSelect   = this.ArticulosxGraduacionResp.filter( e => parseFloat(e.RangoEsfera) === parseFloat(pValorEsfera));
                
                let cilindroSimple     = [];
                let cilindroComplex    = [];
     
                // si fue eliminada la talla y se vuelve a agregar, esta se recupera del original BD y se vuelve a agregar
                if(cilindroSelect.length > 0) {

                    for (let i = 0; i < cilindroSelect.length; i++) {
                        
                        cilindroSimple.push(cilindroSelect[i].RangoCilindro);
                        cilindroComplex.push({
                            IdArticuloTabGraduacion: cilindroSelect[i].IdArticuloTabGraduacion,
                            IdArticuloWeb: cilindroSelect[i].IdArticuloWeb,
                            IdTipoLente: cilindroSelect[i].IdTipoLente,
                            RangoEsfera: cilindroSelect[i].	RangoEsfera,
                            RangoCilindro: cilindroSelect[i].RangoCilindro,
                        });
                    }

                    this.listaEsferasxCilindros.push({
                        RangoEsfera: pValorEsfera,
                        cilindroSelected: cilindroSimple,
                        cilindrosComplex: cilindroComplex
                  
                    });

                }else {
                    // si es una talla nueva que no se tenia, se ingresa el elemento general, con sus atributos en vacio
                    this.listaEsferasxCilindros.push({
                        RangoEsfera: pValorEsfera,
                        cilindroSelected: cilindroSimple,
                        cilindrosComplex: cilindroComplex
                  
                    });
                }

               
                return true;

            }
        },

        remueveEsfera(pEsfera) {
            
            this.listEsferasEliminadas.push(pEsfera.id);
            let newArray = this.listaEsferasxCilindros.filter( e => parseInt(e.RangoEsfera) != parseInt(pEsfera.id));
            this.listaEsferasxCilindros = [];
            this.listaEsferasxCilindros = newArray;
        },

        // CILINDROS
        agregaCilindros(pValorEsfera,pCilindro) {
            console.log('agregando cilindro');

            let EsferaxCilindro = this.listaEsferasxCilindros.filter( e => parseInt(e.RangoEsfera) === parseInt(pValorEsfera));

            if(EsferaxCilindro.length > 0){

                EsferaxCilindro[0].cilindroSelected.push(pCilindro.id);
                EsferaxCilindro[0].cilindrosComplex.push({
                    IdArticuloTabGraduacion: 0,
                    IdArticuloWeb:  this.ArticuloWeb.IdArticuloWeb,
                    IdTipoLente:    this.ArticuloWeb.IdTipoLente,
                    RangoEsfera:    pValorEsfera,
                    RangoCilindro:  pCilindro.id,
                });
            } 
        },

        remueveCilindro(pValorEsfera,pCilindro) {

            this.listCilindrosEliminados.push({
                RangoEsfera:    pValorEsfera,
                RangoCilindro:  pCilindro.id,
            });

            let EsferaxCilindro = this.listaEsferasxCilindros.filter( e => parseInt(e.RangoEsfera) === parseInt(pValorEsfera));

            if(EsferaxCilindro.length > 0) {

                let simple = EsferaxCilindro[0].cilindroSelected.filter( e => parseInt(e) != parseInt(pCilindro.id));
                let complex = EsferaxCilindro[0].cilindrosComplex.filter( e => parseInt(e.RangoCilindro) != parseInt(pCilindro.id));

                EsferaxCilindro[0].cilindroSelected = [];
                EsferaxCilindro[0].cilindroSelected = simple;
                        
                EsferaxCilindro[0].cilindrosComplex = [];
                EsferaxCilindro[0].cilindrosComplex = complex;
            }
        },

        limpiar(){
            // OPCIONES
            this.listaEsferas   = [];
            this.esferasResp    = [];
            this.listaCilindros = [];

            // V-MODELS
            this.ArticulosxGraduacionResp   = [];
            this.listaEsferasSelected       = [];
            this.listaEsferasxCilindros     = [];   
            this.listEsferasEliminadas      = [];
            this.listCilindrosEliminados    = [];
        },

        Regresar() {
           
            switch (this.OrigenList) {

                case 'Lends':
                    let tpLente = ( sessionStorage.getItem('objTipoLente') != undefined ) ? JSON.parse(sessionStorage.getItem('objTipoLente')) : '';
                    let sublinea = ( sessionStorage.getItem('objSublinea') != undefined ) ? JSON.parse(sessionStorage.getItem('objSublinea')) : '';

                     console.log('Intentando Regresar articulosweb desde graduaciones')
                     
                    if(tpLente != undefined && sublinea != undefined) {
                        this.$router.push({name:'articulosweb',params:{pObjTipoLente:tpLente,pObjSublinea:sublinea}});
                    }else {
                        this.$router.push({name:'tiposlentes',params:{}});
                        console.log('not found data!!');
                    }
                    
                    break;
            
                default:
                    this.$router.push({name:'tiposlentes',params:{}});
                    break;
            }
            
        },
    },
    created(){
        this.bus.$off('EmitReturn');

        if(sessionStorage.getItem('OrigenList') != undefined) {
            this.OrigenList = sessionStorage.getItem('OrigenList');
        }
    },
    mounted(){
        if(this.pObjArticuloWeb != undefined) {
            this.ArticuloWeb = this.pObjArticuloWeb;
            sessionStorage.setItem('objArticuloweb',JSON.stringify(this.ArticuloWeb));

        }else if ( sessionStorage.getItem('objArticuloweb') != undefined ){
            this.ArticuloWeb = JSON.parse(sessionStorage.getItem('objArticuloweb'));

        }

        this.getEsferasMatch();
        this.ConfigList.Title = this.ConfigList.Title+' para: '+this.ArticuloWeb.Nombre;

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
